import React from 'react'

const FacebookIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
      <g fill="none" fill-rule="evenodd">
        <path d="M13.13 1.015a12.758 12.758 0 0 0-10.742 18.53l-1.354 6.573a.496.496 0 0 0 .6.583l6.441-1.526a12.755 12.755 0 1 0 5.055-24.16z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="m6.025 16.777 6.412-6.685 3.214 3.105 5.638-3.105-6.383 7-3.184-3.5-5.697 3.185z" fill="#000000" />
      </g>
    </svg>
  )
}

export default FacebookIcon

